<template>
    <div>
        <el-card class="box-card">
          <div class="title">一周佩戴时长</div>
          <div>单位：分钟。</div>
          <div>注意：请当天佩戴完毕之后当天打开小程序上传数据，这样时长数据才准确，否则会有偏差。</div>
          <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="71px" class="mt20">
              <el-form-item label="选择日期">
                <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="请选择一个日期" class="mr15"></el-date-picker>
              </el-form-item>
              <el-form-item>
                  <el-button type="primary" @click="apiYanYunDongShiChangTuBiao">查询</el-button>
              </el-form-item>
          </el-form>
          <ve-line :data="lineData"></ve-line>
        </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      keywords: {
        begintime:'',
        userid:'',
      },
      lineData: {
        columns: ['DATE', '时长'],
        rows: []
      }
    }
  },
  mounted () {
    this.keywords.begintime = Vue.prototype.FunGetTimeStringShort()
    this.keywords.userid = this.$route.query.userid;
    this.apiYanYunDongShiChangTuBiao();
  },
  methods: {
    apiYanYunDongShiChangTuBiao: function () {
      var that = this
      var data = {
        begintime: that.keywords.begintime,
        userid: that.keywords.userid
      }
      axios.post(Vue.prototype.global.Url_YanYunDongShiChangTuBiao, Qs.stringify(data))
        .then(function (response) {
          console.log(response.data)
          if (response.data.Code == 200) {
            that.lineData.rows = []
            response.data.List.filter((item1, i1) => {
              that.lineData.rows.push({ DATE: item1.Date, 时长: item1.Num })
            })
          } else {
            Vue.prototype.FunAlertMsg(response.data.Errormsg)
          }
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
